import { FieldLabel, Select, TextInput } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function GeocodeInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Address column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Provider</FieldLabel>
      <Select value={c.provider || 'mapbox'} onChange={(v) => u({ provider: v })}
        options={[
          { value: 'mapbox', label: 'Mapbox' },
          { value: 'google', label: 'Google Maps' },
          { value: 'opencage', label: 'OpenCage' },
          { value: 'nominatim', label: 'Nominatim (OSM)' },
        ]} />
      <FieldLabel>Output columns</FieldLabel>
      <div style={{ display: 'flex', gap: 6 }}>
        <TextInput mono value={c.latCol ?? 'lat'} onChange={(v) => u({ latCol: v })} />
        <TextInput mono value={c.lonCol ?? 'lon'} onChange={(v) => u({ lonCol: v })} />
      </div>
    </div>
  );
}
